// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it
import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import meta from './data/meta.json';
import Zion from './utils/Zion';
import stamp1 from './img/stamp-1.png';
import stamp2 from './img/stamp-2.png';


// styles
import './styles/index.scss';
import './styles/graphic.scss';

console.log('index.js is loaded');

const pkg = require('../package.json');

let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

// console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // console.log('pymChild:', pymChild);

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html during development mode.
    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;
    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
}

function toggleElements(elements, inview) {
  elements.forEach(element => element.classList.toggle('inview', inview));
}

function overlapsArtboard(element, artboardRect) {
  const rect = element.getBoundingClientRect();
  return rect.right > artboardRect.left
    && rect.left < artboardRect.right
    && rect.bottom > artboardRect.top
    && rect.top < artboardRect.bottom;
}

function getSectionIndex(y, anchors) {
  let sectionIndex = 0;

  anchors.forEach((anchor, index) => {
    if (y >= anchor.offsetTop) sectionIndex = index;
  });

  return sectionIndex;
}

function getStampBounds(stamp) {
  const transform = stamp.transform.baseVal.consolidate();
  const matrix = transform ? transform.matrix : {
    a: 1, d: 1, e: 0, f: 0,
  };

  return {
    x: matrix.e,
    y: matrix.f,
    width: parseFloat(stamp.getAttribute('width')) * Math.abs(matrix.a),
    height: parseFloat(stamp.getAttribute('height')) * Math.abs(matrix.d),
  };
}

function updateGraphic(parentInfo) {
  const positions = parentInfo.split(' ').map(pos => parseFloat(pos));
  const viewportHeight = positions[1];
  const iframeTop = positions[2];
  const boxTrigger = viewportHeight * 0.72;
  const detailTrigger = viewportHeight * 0.35;
  const artboards = Array.from(document.querySelectorAll('.g-artboard'));
  const artboard = artboards.find((node) => {
    const styles = getComputedStyle(node);
    return styles.display !== 'none' && node.getBoundingClientRect().width > 0;
  });

  artboards
    .filter(node => node !== artboard)
    .forEach(node => node.classList.remove('is-animated'));

  if (!artboard || !artboard.querySelector('svg')) return;

  const artboardRect = artboard.getBoundingClientRect();
  const boxText = Array.from(artboard.children)
    .filter(element => element.id === 'box-text');
  const anchors = boxText
    .filter(element => element.textContent.trim().indexOf('Plan ') === 0)
    .sort((a, b) => a.offsetTop - b.offsetTop);

  if (!anchors.length) return;

  artboard.classList.add('is-animated');

  const boxElements = Array.from(artboard.querySelectorAll('[data-name="box"]'))
    .filter(element => overlapsArtboard(element, artboardRect));
  const svg = artboard.querySelector('svg');
  const svgWidth = svg.viewBox.baseVal.width;
  const stampImages = Array.from(artboard.querySelectorAll('[data-name="stamp"]'))
    .filter((stamp) => {
      const bounds = getStampBounds(stamp);
      return bounds.x + bounds.width > 0 && bounds.x < svgWidth;
    })
    .sort((a, b) => getStampBounds(a).y - getStampBounds(b).y);
  const stampSources = [stamp1, stamp2];

  stampImages.forEach((stamp, index) => {
    stamp.setAttribute('href', stampSources[index]);
    stamp.setAttributeNS('http://www.w3.org/1999/xlink', 'href', stampSources[index]);
  });

  const stamps = stampImages
    .map((stamp) => {
      if (stamp.parentElement.classList.contains('stamp-animation')) {
        return stamp.parentElement;
      }

      const wrapper = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      wrapper.classList.add('stamp-animation');
      stamp.parentNode.insertBefore(wrapper, stamp);
      wrapper.appendChild(stamp);
      return wrapper;
    });

  anchors.forEach((anchor, index) => {
    const nextAnchor = anchors[index + 1];
    const anchorTop = anchor.getBoundingClientRect().top + iframeTop;
    const boxInview = anchorTop < boxTrigger;
    const nextAnchorTop = nextAnchor
      ? nextAnchor.getBoundingClientRect().top + iframeTop
      : Infinity;
    const stampInview = nextAnchorTop < boxTrigger;
    const sectionBoxes = boxElements.filter((box) => {
      const rect = box.getBoundingClientRect();
      const centerY = rect.top - artboardRect.top + (rect.height / 2);
      return getSectionIndex(centerY, anchors) === index;
    });
    const sectionText = boxText.filter(text => (
      getSectionIndex(text.offsetTop, anchors) === index
    ));

    toggleElements(sectionBoxes, boxInview);
    toggleElements(sectionText, boxInview);
    toggleElements([stamps[index]].filter(Boolean), stampInview);
  });

  const line = Array.from(artboard.querySelectorAll('[data-name="line"]'))
    .find(element => overlapsArtboard(element, artboardRect));

  if (line) {
    const lineTop = line.getBoundingClientRect().top + iframeTop;
    const lineHeight = line.getBoundingClientRect().height;
    const progress = Math.max(0, Math.min(1,
      (detailTrigger - lineTop) / lineHeight));
    const length = line.getTotalLength();

    line.style.strokeDasharray = length;
    line.style.strokeDashoffset = length * (1 - progress);
    line.style.opacity = progress > 0 ? 1 : 0;
  }
}

window.pymChild.onMessage('viewport-iframe-position', updateGraphic);

setInterval(() => {
  window.pymChild.getParentPositionInfo();
}, 200);

// function rAf() {
//   window.pymChild.getParentPositionInfo();
//   requestAnimationFrame(rAf);
// }
// rAf();
